import gql from "graphql-tag";

export const SHARE_LINK = gql`
query getShareLink {
    getShareLink
}
`;